import { useQuery } from '@tanstack/react-query'
import { getLocationOverrideRule } from '../../../api/plan-location-override-rules-api'

export const LOCATION_OVERRIDE_RULE_QUERY_KEY = 'locationOverrideRule'

export function useGetLocationOverrideRule(id: string | undefined) {
  return useQuery({
    queryKey: [LOCATION_OVERRIDE_RULE_QUERY_KEY, id],
    queryFn: () => getLocationOverrideRule(id as string),
    enabled: !!id,
    staleTime: 0,
  })
}
